import { c as _c } from "react/compiler-runtime";
import { CompanyMemberRole } from "@components/table/members/members-column/role-column/company-member-role";
import { useCompanyId } from "@context-providers/company-id-provider";
/** Dropdown to display and change the workspace role of a member or team */
export function WorkspaceRoleDropdown(t0) {
  const $ = _c(9);
  const {
    member,
    isReadOnly: t1,
    teamName
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const companyId = useCompanyId();
  const {
    role,
    identity
  } = member;
  let t2;
  if ($[0] !== identity || $[1] !== role) {
    t2 = {
      role,
      identity
    };
    $[0] = identity;
    $[1] = role;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      slotProps: {
        paper: {
          sx: {
            width: "270px"
          }
        }
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== companyId || $[5] !== isReadOnly || $[6] !== t2 || $[7] !== teamName) {
    t4 = <CompanyMemberRole companyId={companyId} memberIdentityRole={t2} isReadOnly={isReadOnly} variant="standard" location="workspace-role-dropdown" teamName={teamName} menuProps={t3} />;
    $[4] = companyId;
    $[5] = isReadOnly;
    $[6] = t2;
    $[7] = teamName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}